var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.tasks,"items-per-page":500,"footer-props":{
    itemsPerPageText: '',
    itemsPerPageAllText: _vm.$t('all'),
    'items-per-page-options': [10, 100, 200, 500, -1],
  },"dense":""},scopedSlots:_vm._u([{key:`footer.page-text`,fn:function(items){return [_vm._v(" "+_vm._s(items.pageStart)+" - "+_vm._s(items.pageStop)+" / "+_vm._s(items.itemsLength)+" ")]}},{key:"no-data",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("no_data_text"))+" ")]},proxy:true}],null,true)},[_c('template',{slot:"no-results"},[_vm._v(" "+_vm._s(_vm.$t("no_results"))+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }